import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import waterVertexShader from './shaders/water/vertex.glsl'
import waterFragmentShader from './shaders/water/fragment.glsl'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

/**
 * Base
 */
// Texture loader
const textureLoader = new THREE.TextureLoader()

// GLTF loader
const gltfLoader = new GLTFLoader()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()


//Scene Texture
const bakedTexture = textureLoader.load('Thunder.jpg')
bakedTexture.flipY = false
bakedTexture.encoding = THREE.sRGBEncoding


/**
 * Materials
 */
//Baked Material
const bakedMaterial = new THREE.MeshBasicMaterial({ map: bakedTexture })

/**
 * Water
 */
// Geometry
const waterGeometry = new THREE.PlaneBufferGeometry(10, 10, 512, 512)

// Colors
const depthColor2 = '#186691'
const surfaceColor2 = '#c27e00'


// Material
const waterMaterial2 = new THREE.ShaderMaterial({
    vertexShader: waterVertexShader,
    fragmentShader: waterFragmentShader,
    uniforms:
    {
        uTime: { value: 0 },

        uBigWavesElevation: { value: 0.045 },
        uBigWavesFrequency: { value: new THREE.Vector2(4, 1.5) },
        uBigWavesSpeed: { value: 0.75 },

        uSmallWavesElevation: { value: 0.15 },
        uSmallWavesFrequency: { value: 3 },
        uSmallWavesSpeed: { value: 0.2 },
        uSmallIterations: { value: 4 },

        uDepthColor: { value: new THREE.Color(depthColor2) },
        uSurfaceColor: { value: new THREE.Color(surfaceColor2) },
        uColorOffset: { value: 0.08 },
        uColorMultiplier: { value: 5 }
    }
})


// Colors
const depthColor = '#186691'
const surfaceColor = '#001fff'







// Material
const waterMaterial = new THREE.ShaderMaterial({
    vertexShader: waterVertexShader,
    fragmentShader: waterFragmentShader,
    uniforms:
    {
        uTime: { value: 0 },

        uBigWavesElevation: { value: 0.045 },
        uBigWavesFrequency: { value: new THREE.Vector2(4, 1.5) },
        uBigWavesSpeed: { value: 0.75 },

        uSmallWavesElevation: { value: 0.15 },
        uSmallWavesFrequency: { value: 3 },
        uSmallWavesSpeed: { value: 0.2 },
        uSmallIterations: { value: 4 },

        uDepthColor: { value: new THREE.Color(depthColor) },
        uSurfaceColor: { value: new THREE.Color(surfaceColor) },
        uColorOffset: { value: 0.08 },
        uColorMultiplier: { value: 5 }
    }
})




// Mesh
const water = new THREE.Mesh(waterGeometry, waterMaterial)
water.rotation.x = - Math.PI * 0.5
scene.add(water)



// lIGHT Start here


const Button = document.querySelector('#buttonSub');
Button.addEventListener('click', init1);




function init1() {
    const LightNumber = document.querySelector('#LightNumber').value;
    const LightWatt = document.querySelector('#LightWatt').value;
    const HourNumber = document.querySelector('#LightHour').value;
    const m1 = LightNumber *
        LightWatt *
        HourNumber * 3.86 / (1000);
    const FanNumber = document.querySelector('#FanNumber').value;
    const FanWatt = document.querySelector('#FanWatt').value;
    const FanHour = document.querySelector('#FanHour').value;
    const m2 = FanNumber *
        FanWatt *
        FanHour * 3.86 / (1000);
    const ACNumber = document.querySelector('#ACNumber').value;
    const ACWatt = document.querySelector('#ACWatt').value;
    const ACHour = document.querySelector('#ACHour').value;
    const m3 = ACNumber *
        ACWatt *
        ACHour * 3.86 / (1000);

    const PCNumber = document.querySelector('#PCNumber').value;
    const PCWatt = document.querySelector('#PCWatt').value;
    const PCHour = document.querySelector('#PCHour').value;
    const m4 = PCNumber *
        PCWatt *
        PCHour * 3.86 / (1000);
    const TVNumber = document.querySelector('#TVNumber').value;
    const TVWatt = document.querySelector('#TVWatt').value;
    const TVHour = document.querySelector('#TVHour').value;
    const m5 = TVNumber *
        TVWatt *
        TVHour * 3.86 / (1000);
    const WashNumber = document.querySelector('#WashNumber').value;
    const WashWatt = document.querySelector('#WashWatt').value;
    const WashHour = document.querySelector('#WashHour').value;
    const m6 = WashNumber *
        WashWatt *
        WashHour * 3.86 / (1000);
    const DishNumber = document.querySelector('#DishNumber').value;
    const DishWatt = document.querySelector('#DishWatt').value;
    const DishHour = document.querySelector('#DishHour').value;
    const m7 = DishNumber *
        DishWatt *
        DishHour * 3.86 / (1000);
    const IronNumber = document.querySelector('#IronNumber').value;
    const IronWatt = document.querySelector('#IronWatt').value;
    const IronHour = document.querySelector('#IronHour').value;
    const m8 = IronNumber *
        IronWatt *
        IronHour * 3.86 / (1000);
    const geyNumber = document.querySelector('#geyNumber').value;
    const geyHour = document.querySelector('#geyHour').value;
    const geyWatt = document.querySelector('#geyWatt').value;
    const m9 = geyNumber *
        geyHour *
        geyWatt;
    const OvenNumber = document.querySelector('#OvenNumber').value;
    const OvenWatt = document.querySelector('#OvenWatt').value;
    const OvenHour = document.querySelector('#OvenHour').value;
    const m10 = OvenNumber *
        OvenWatt *
        OvenHour * 3.86 / (1000);
    const RefNumber = document.querySelector('#RefNumber').value;
    const RefWatt = document.querySelector('#RefWatt').value;
    const RefHour = document.querySelector('#RefHour').value;
    const m11 = RefNumber *
        RefWatt *
        RefHour * 3.86 / (1000);
    const coolNumber = document.querySelector('#coolNumber').value;
    const coolWatt = document.querySelector('#coolWatt').value;
    const coolHour = document.querySelector('#coolHour').value;
    const m12 = coolNumber *
        coolWatt *
        coolHour * 3.86 / (1000);
    const WaterNumber = document.querySelector('#WaterNumber').value;
    const WaterWatt = document.querySelector('#WaterWatt').value;
    const WaterHour = document.querySelector('#WaterHour').value;
    const m13 = WaterNumber *
        WaterWatt *
        WaterHour * 3.86 / (1000);
    const OthNumber = document.querySelector('#OthNumber').value;
    const OthWatt = document.querySelector('#OthWatt').value;
    const OthHour = document.querySelector('#OthHour').value;
    const m14 = OthNumber *
        OthWatt *
        OthHour * 3.86 / (1000);
    //Monthly bILL
    const bill1 = (m1 + m2 + m3 + m4 + m5 + m6 + m7 + m8 + m9 + m10 + m11 + m12 + m13 + m14) * 30
    const bill = bill1.toFixed(2);
    console.log(bill);
    document.querySelector("#overlay").style.display = "none";
    scene.remove(water)
    // Mesh
    const water2 = new THREE.Mesh(waterGeometry, waterMaterial2)
    water2.rotation.x = - Math.PI * 0.5
    scene.add(water2)
    document.querySelector("#Result").style.visibility = "visible";
    const header = document.querySelector("#rup");
    header.textContent = bill;





    //Calculating Solar panel Price 
    const SolarPrice = (LightWatt*LightNumber +FanWatt* FanNumber +ACWatt*ACNumber  +PCWatt* PCNumber +TVWatt*TVNumber + WashWatt*WashNumber + DishWatt*DishNumber +IronWatt*IronNumber +geyWatt*geyNumber + OvenWatt*OvenNumber +RefWatt*RefNumber + coolWatt*coolNumber + WaterWatt* WaterNumber + OthWatt*OthNumber) *10/ bill;
    const header2 = document.querySelector("#months");
    
    header2.textContent = Math.round((SolarPrice+Number.EPSILON)*100)/100;
   
    



    gltfLoader.load(
        'thunder.glb',
        (gltf) => {
            gltf.scene.traverse((child) => {
                child.material = bakedMaterial
            })
            gltf.scene.scale.set(0.04, 0.04, 0.04);
            scene.add(gltf.scene)
        })


}



const Refresh = document.querySelector('#Refresh');
Refresh.addEventListener('click', refresh);


function refresh() {
    window.location.reload();
}






/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(1, 1, 1)
scene.add(camera)


// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.minPolarAngle = Math.PI / 2.2;

controls.maxPolarAngle = Math.PI / 2.2;
controls.maxDistance = 1
controls.minDistance = 1

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () => {
    const elapsedTime = clock.getElapsedTime()

    // Water
    waterMaterial.uniforms.uTime.value = elapsedTime
    waterMaterial2.uniforms.uTime.value = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()